import { useEffect } from 'react';

import globalStore from 'src/stores/global-store';

const useQueryParams = () => {
  const { queryParams } = globalStore;

  useEffect(() => {
    try {
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}${queryParams ? `?${queryParams}` : ''}`
      );
    } catch (e) {
      console.log(e);
    }
  }, [queryParams]);
};

export default useQueryParams;
